module.exports = __webpack_public_path__ + "static/media/003ty@4x.dd9d31c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/003ty@4x.png
// module id = 410
// module chunks = 0 1